/**
 * EmptyValue component for displaying a consistent empty/null state indicator
 * Uses an en-dash (–) with muted styling to indicate missing or unavailable data
 */
export const EmptyValue = () => <span className="text-muted-foreground">–</span>;
